import { ReactComponent as Logo } from 'assets/icons/playlegis-icon.svg';
import { PUBLIC_ROUTES } from 'helpers/constants';
import { HTMLButton as Button, ButtonLink as Link } from 'components/Button';

import * as S from '../../styled';

const RecoverStepTwo = () => (
    <S.RecoverPasswordContent>
        <Logo />
        <h1>Recuperação de Senha</h1>
        <p>Enviamos um link para o seu e-mail. Por favor, verifique sua caixa de entrada (ou spam) e clique no link para redefinir sua senha.</p>
    </S.RecoverPasswordContent>
);

export default RecoverStepTwo;
